import "core-js/modules/es6.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import baseStyles, { mergeStyles } from '@nerdwallet/base-styles/react';
import { Box } from '../Box/Box';
import { Type } from '../Type/Type';

var Quote = function Quote(_ref) {
  var text = _ref.text,
      hasAttribution = _ref.hasAttribution;
  return /*#__PURE__*/React.createElement(Box, {
    component: "blockquote",
    position: "relative",
    marginBottom: hasAttribution ? '2' : undefined
  }, /*#__PURE__*/React.createElement(Type, _extends({
    inline: true,
    size: 4,
    chronicle: true
  }, mergeStyles(baseStyles('position-absolute'), {
    style: {
      right: '100%'
    }
  })), "\u201C"), /*#__PURE__*/React.createElement(Type, {
    inline: true,
    size: 4,
    chronicle: true
  }, text, /*#__PURE__*/React.createElement(Type, {
    inline: true
  }, "\u201D")));
};

var Attribution = function Attribution(_ref2) {
  var text = _ref2.text;
  return /*#__PURE__*/React.createElement(Type, {
    gotham: true,
    size: 1
  }, text);
};

// TODO: in Currency v2, BlockQuote should take the quote as a child
export var BlockQuote = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var quote = _ref3.quote,
      _ref3$attribution = _ref3.attribution,
      attribution = _ref3$attribution === void 0 ? null : _ref3$attribution;
  return /*#__PURE__*/React.createElement(Box, _extends({
    paddingLeft: "4"
  }, mergeStyles(baseStyles('max-width-prose-wide')), {
    ref: ref
  }), /*#__PURE__*/React.createElement(Quote, {
    text: quote,
    hasAttribution: !!attribution
  }), attribution && /*#__PURE__*/React.createElement(Attribution, {
    text: attribution
  }));
});
BlockQuote.displayName = 'BlockQuote';